import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState } from 'src/entity/StateEntity';
import PharmacyAddComponent from 'src/components/views/Mall/PharmacyAdd';

const mapStateToProps = ({ userState: {isAgent },mallCategoryState: { categoryList }, mallBrandState: { brandList } }: IStoreState) => ({
  isAgent,
  categoryList: categoryList || [],
  brandList: brandList || [],
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyAddComponent);



// WEBPACK FOOTER //
// ./src/containers/MallPharmacyAdd.ts